import { ErrorIcon } from '@authentic/loyalty-pwa/icons';
import { Typography } from '@authentic/loyalty-pwa/util';
import { colors } from '@authentic/loyalty-pwa/util/variables';
import { h } from 'preact';
import styled from 'styled-components';

const ErrorStyled = styled.div`
  color: ${colors.red};
  margin-bottom: 16px;

  .ico {
    display: inline-block;
    margin-right: 4px;
    vertical-align: middle;
  }
`;

export const ErrorMessage = (props: any) => (
  <ErrorStyled>
    <Typography variant="body1" weight="bold">
      <div className="ico">
        <ErrorIcon />
      </div>
      {props.children}
    </Typography>
  </ErrorStyled>
);
